<template>
     <div v-if="open" >
        <WindowForNew :title="title" ref="editBusiness" :size="'m'" >
            <div slot="headButton" class="fR cb tra-fast_E ml05x_E">
                <button class="bdSub boxR hover-bg-highLight" @click="Close">{{$t('cmd85',['取消'])}}</button>
                <button @click="save" type="button" class="functionBtn" :class="{disable:active ==-1}">{{$t('cmd84',['保存'])}}</button>
            </div>
            <div class="w60pct mc mt4x posR">
               	 <ul class="w44pct_E dpIB_E mt2x_E vaT_E">
                    <li>
                        <div class="cSub mb1x" :title="data.type==1?getLanguageStr('word1963','商家名称'):getLanguageStr('word67','姓名')">{{data.type==1?getLanguageStr('word1963','商家名称'):getLanguageStr('word67','姓名')}}</div>
                        <div v-if="relative=='edit'">{{data.type==1?data.orgDto.org.name:data.userInfoDto.userInfo.name}}</div>
                        <div v-else>{{data.type==1?data.name:data.userInfo.name}}</div>
                    </li>
                    <li>
                        <div class="cSub mb1x" :title="getLanguageStr('word1657','授权外部角色')"><span class="cWarning">* </span>{{getLanguageStr('word1657','授权外部角色')}}</div>
                        <Select :list="selectList" @Click="SelectValue" :bindActive="active"></Select>
                    </li>
                </ul>
            </div>
        </WindowForNew>
    </div>
</template>
<script>
import * as lib from '@/util/lib.js'
import {getLanguageStr} from '@/util/language.js'

import WindowForNew from '@/components/common/ui/WindowForNew.vue'
import Loading from '@/components/common/ui/Loading'
import Select from '@/components/common/ui/Select.vue'
import {getOutRoles} from '@/api/manage/roleFunc.js'
import {EditEntityRelBus, EditEntityRelUser, AddBusRole, AddUserRole} from '@/api/manage/externalRelative.js'
export default {
  name: 'editBusiness',
  components: {WindowForNew, Select},
  data () {
    return {
      data: {},
      open: false,
      active: 0,
      selectList: [],
      title: '',
      relative: 'edit'
    }
  },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    reset () {
      this.open = false
      this.relative = 'edit'
      this.title = ''
      this.active = -1
    },
    show (data) {
      this.reset()
      this.open = true
      this.data = data
      this.relative = data.relative
      if (data.relative == 'edit') {
        if (data.type == 1) {
          this.title = getLanguageStr('word1644', '编辑商家')
        } else {
          this.title = getLanguageStr('cmd99', '编辑用户')
        }
      } else {
        if (data.type == 1) {
          this.title = getLanguageStr('cmd174', '添加已有商家')
        } else {
          this.title = getLanguageStr('word1688', '添加已有用户')
        }
      }
      this._getRoleList()
      setTimeout(() => {
        this.$refs.editBusiness.show()
      }, 10)
    },
    _getRoleList () {
      this.selectList = []
      let request = {
        applyScope: this.data.type == 1 ? 2 : 1, // 1:用户，2：商家
        pageNum: 1,
        pageSize: 50,
        modules: 2 // 1:内部 2：外部
      }
      getOutRoles(request).then(res => {
        if (res.total > 0) {
          this.selectList = res.roleList.map(el => ({
            value: el.roleId,
            text: this.getTypeText(el.roleId,'roleType-outer')?this.getTypeText(el.roleId,'roleType-outer'):el.roleName
          }))
          this.selectList.unshift({text: getLanguageStr('word66', '-请选择-'), value: -1,token:true})
          if (JSON.stringify(this.data) != '{}' && this.relative == 'edit') {
            this.active = this.data.entityRel.roleId?this.data.entityRel.roleId:-1
          }
        }
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    SelectValue (index) {
      this.active = this.selectList[index].value
    },
    Close () {
      this.$refs.editBusiness.hide()
      setTimeout(() => {
        this.open = false
      }, 500)
    },
    save () {
      let request
      if (this.relative == 'edit') {
        request = {
          roleId: this.active
        }
        if (this.data.type == 1) {
          EditEntityRelBus(this.data.entityRel.id, request).then(res => {
            this.Close()
            this.$emit('update',this.data.entityRel.id)
          }, error => {
            !_.isEmpty(error) && this.$notify(error)
          })
        } else {
          EditEntityRelUser(this.data.entityRel.id, request).then(res => {
            this.Close()
            this.$emit('update',this.data.entityRel.id)
          }, error => {
            !_.isEmpty(error) && this.$notify(error)
          })
        }
      } else {
        request = {
          targetEntityId: this.data.type == 1 ? this.data.id : this.data.userInfo.id,
          roleId: this.active
          // targetEntityType: this.data.type
        }
        if (this.data.type == 1) {
          AddBusRole(request).then(res => {
            this.Close()
            this.$emit('update', res)
          }, error => {
            !_.isEmpty(error) && this.$notify(error)
          })
        } else {
          AddUserRole(request).then(res => {
            this.Close()
            this.$emit('update', res)
          }, error => {
            !_.isEmpty(error) && this.$notify(error)
          })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/manage/account/EditRelative.vue